import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { StaticImage } from '../../../image'
import { TENANT } from '../../../tenant'
import { urlResolverNfcLandingPage } from '../../../url-handling'

import ImgNfcIllustration from './illustration-nfc.png'

const accentuateTextItalicHighlight = (text: ReactNode[]): ReactElement => (
  <span className="font-medium italic text-dark-brand">{text}</span>
)

const lineBreak = (): ReactElement => <br />

export const ProductPrescriptionNfcInfo: FC = () => {
  const config = useGlobalConfigContext()
  const intl = useIntl()

  if (config.tenant !== TENANT.COM) {
    return null
  }

  return (
    <li className="m-3 space-y-3 rounded-2xl border border-dark-primary-min p-4 tablet:hidden">
      <div className="flex items-center">
        <StaticImage
          alt={intl.formatMessage({ id: 'rxSelectModal.title' })}
          className="mr-4"
          src={ImgNfcIllustration}
          width={95}
        />
        <div className="w-full text-m font-medium">
          <FormattedMessage
            id="rxSelectModal.nfc.title"
            values={{
              accentuate: accentuateTextItalicHighlight,
              break: lineBreak,
            }}
          />
        </div>
      </div>
      <div className="text-s">
        <FormattedMessage id="rxSelectModal.nfc.info" />
      </div>
      <Button<'a'>
        className="w-full"
        href={urlResolverNfcLandingPage(config)}
        size="medium"
        slots={{ root: 'a' }}
        variant="outlined"
      >
        <FormattedMessage id="rxSelectModal.nfc.button" />
      </Button>
    </li>
  )
}
